import { AnyAction, Reducer } from "redux";
import { IAppThunkAction } from ".";
import AppConfigApi from "../api/AppConfigApi";
import { LoadState } from "../models/utility/LoadState";

export interface IAppConfigStoreState {
    analyticsKey: string;
    configState: LoadState;
    instrumentationKey: string;
    salesPageUrl: string;
    stackAdaptPixelId: string;
}

export type KnownAction = ILoadAppConfig | IUpdateAppConfig;

export interface ILoadAppConfig {
    type: "APP_CONFIG_LOAD_STATE";
    configState: LoadState;
}

export interface IUpdateAppConfig {
    type: "APP_CONFIG_UPDATE";
    analyticsKey: string;
    configState: LoadState;
    instrumentationKey: string;
    salesPageUrl: string;
    stackAdaptPixelId: string;
}

export const actionCreators = {
    loadAppConfig: (): IAppThunkAction => async (dispatch) => {
        dispatch({
            type: "APP_CONFIG_LOAD_STATE",
            configState: LoadState.Loading
        });

        const response = await AppConfigApi.GetConfig();
        dispatch({
            type: "APP_CONFIG_UPDATE",
            analyticsKey: response.analyticsKey,
            configState: LoadState.Loaded,
            instrumentationKey: response.instrumentationKey,
            salesPageUrl: response.salesPageUrl,
            stackAdaptPixelId: response.stackAdaptPixelId
        });
    }
};

export const reducer: Reducer<IAppConfigStoreState> = (
    state: IAppConfigStoreState | undefined,
    incomingAction: AnyAction
) => {
    const action = incomingAction as KnownAction;
    const prevState = state || defaultState;

    switch (action.type) {
        case "APP_CONFIG_LOAD_STATE": {
            return {
                analyticsKey: prevState.analyticsKey,
                configState: action.configState,
                instrumentationKey: prevState.instrumentationKey,
                salesPageUrl: prevState.salesPageUrl,
                stackAdaptPixelId: prevState.stackAdaptPixelId
            };
        }
        case "APP_CONFIG_UPDATE": {
            return {
                analyticsKey: action.analyticsKey,
                configState: action.configState,
                instrumentationKey: action.instrumentationKey,
                salesPageUrl: action.salesPageUrl,
                stackAdaptPixelId: action.stackAdaptPixelId
            };
        }
        default:
            break;
    }

    return prevState;
};

export const defaultState = {
    analyticsKey: "",
    configState: LoadState.NotLoaded,
    instrumentationKey: "",
    salesPageUrl: "",
    stackAdaptPixelId: ""
} as IAppConfigStoreState;
